<script setup>
import SendLastReportAction from "@frontJs/components/actions/projectManagement/customers/SendLastReportAction.vue";
import { EnvelopeIcon, EyeIcon } from "@heroicons/vue/24/outline";
import ActionButton from "@js/components/ActionButton.vue";
import { computed } from "vue";
import { toast } from "vue3-toastify";
import { useI18n } from "vue-i18n";

const { t } = useI18n();

const { row, callback } = defineProps({
  row: {
    type: Object,
    required: true,
  },
  callback: {
    type: Function,
    required: true,
  },
});

const previewUrl = computed(() => {
  return (
    "/" +
    row.original.id +
    "/login?token=" +
    row.original.adminLoginToken +
    "&redirect=app.apikom.strategyAndObjectives"
  );
});

function sendLastReportCallback() {
  toast.success(t("toast.successfullySent"), {
    position: "top-right",
  });

  callback();
}
</script>

<template>
  <div class="flex h-full items-center gap-2 p-4">
    <ActionButton
      size="small"
      type="secondary"
      class="size-8"
      :href="previewUrl"
      target="_blank"
      :title="t('button.preview')"
      :icon="EyeIcon"
    />

    <SendLastReportAction
      :tenant="row.original"
      :callback="sendLastReportCallback"
    >
      <template #button="{ setIsOpen }">
        <ActionButton
          size="small"
          type="primary"
          class="size-8"
          :callback="() => setIsOpen(true)"
          :title="t('button.sendLastReport')"
          :icon="EnvelopeIcon"
        />
      </template>
    </SendLastReportAction>
  </div>
</template>
